var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import AddHolidayDialog from '@/views/Roster/AddHolidayDialog';
import { Holiday as HolidayModel } from '@/models/Holiday';
import { formatDate as format } from '@/support/String';
import ErrorHandler from '@/support/ErrorHandler';
import { RolesEnum } from '@/items/Roles';
let Holiday = class Holiday extends Vue {
    constructor() {
        super(...arguments);
        this.selected = [];
        this.isAddingHolidayDialog = false;
        this.selectedHoliday = null;
    }
    mounted() { }
    dropdown() {
        return this.tableOptions.dropdown;
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('holiday.title', 1),
                plural: this.$tc('holiday.title', 2),
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'title',
                    editable: true,
                    changed: false,
                },
                {
                    text: this.$t('starts.title'),
                    type: 'date',
                    modal: false,
                    value: 'starts_at',
                    editable: true,
                    changed: false,
                    sortable: {
                        key: 'starts_at',
                        order: 'DESC',
                    },
                    transform: (date) => {
                        return format(date, 'yyyy-LL-dd');
                    },
                },
                {
                    text: this.$t('ends.title'),
                    type: 'date',
                    modal: false,
                    value: 'ends_at',
                    editable: true,
                    changed: false,
                    sortable: {
                        key: 'ends_at',
                        order: 'DESC',
                    },
                    transform: (date) => {
                        return format(date, 'yyyy-LL-dd');
                    },
                },
            ],
            actions: [
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, holiday) => {
                        this.selectedHoliday = holiday;
                        this.$store.dispatch('openDialog', this.DeleteSingleHolidayDialogOptions);
                    },
                },
            ],
            dropdown: [
                {
                    text: this.$tc('actions.delete', 1) + ' ' + this.$tc('holiday.title', 2),
                    icon: 'delete',
                    action: (vm) => {
                        this.$store.dispatch('openDialog', this.deleteMultipleHolidayDialogOptions);
                    },
                    roles: [RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.TRAINER],
                },
            ],
            filters: [],
            model: new HolidayModel().sort('starts_at', 'DESC' || null),
        };
    }
    get DeleteSingleHolidayDialogOptions() {
        const holiday = this.selectedHoliday;
        return {
            title: holiday.title || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, {
                item: this.$t('dialogOptions.item.user'),
            }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        holiday
                            .delete()
                            .then(() => {
                            this.refreshDataTable();
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedHoliday = null;
                    },
                },
            },
        };
    }
    get deleteMultipleHolidayDialogOptions() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, {
                item: this.$t('dialogOptions.item.user'),
            }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: async () => {
                        try {
                            const userIds = this.selected.map((holiday) => holiday.id || '');
                            await new HolidayModel().deleteMany(userIds);
                            this.selected = [];
                            this.refreshDataTable();
                        }
                        catch (error) {
                            ErrorHandler.network(error);
                        }
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selected = [];
                        this.refreshDataTable();
                    },
                },
            },
        };
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
                dataTable.resetSelected();
            },
        }));
    }
    handleNewHoliday() {
        this.refreshDataTable();
    }
};
Holiday = __decorate([
    Component({
        components: {
            PageHeader,
            DataTable,
            AddHolidayDialog,
        },
    })
], Holiday);
export default Holiday;
